<template>
    <div id="new">
        <ErrorMessages :errors="errors" :description="$t('ui.general.error')" :is_closable="true"></ErrorMessages>
        <div class="contents">
            <div class="ui form" :class="{'loading': is_loading}">
                <div class="field">
                    <label>{{ $t('models.attributes.roles.name') }}</label>
                    <input type="text" class="name" v-model="role.name">
                </div>

                <div is="PermissionsTable" :role="role"></div>

                <div class="ui basic positive button" @click="create">
                    {{ $t('ui.general.submit') }}
                </div>
                <router-link :to="{name: 'roles'}" class="ui basic button">
                    <i class="undo icon"></i>
                    {{ $t('ui.general.back') }}
                </router-link>
            </div>

        </div>
    </div>
</template>

<script>
import ErrorMessages from '@toolbox/error_box/main.vue'
import PermissionsTable from './permissions_table.vue'
export default {
    name: "NewRole",
    data: function () {
        return {
            is_loading: false,
            errors: [],
            role: {
                name: null,
                permission_identities: [],
            }
        }
    },
    mounted: function() {
        var that = this;
    },
    computed: {
    },
    methods: {
        create: function() {
            var that = this;
            var url = that.$store.state.provider.routes.api_v1_provider_role_create;

            that.errors = [];
            that.is_loading = true;
            axios.post(url, that.role, {headers: { Authorization: localStorage.getItem("authentication_token") }})
                .then(function (response) {
                    if (response.data.status == "success") {
                        // that.$noty.success('建立職位成功');
                        that.$noty.success(
                            that.$t('ui.notifications.success.create__name', {
                                name: that.$t('models.roles')
                            })
                        );
                        that.$router.push({name: "roles"});
                    } else {
                        console.log(reponse.data);
                        // that.$noty.error('無法建立職位');
                        that.$noty.error(
                            that.$t('ui.notifications.error.create__name', {
                                name: that.$t('models.roles')
                            })
                        );
                    }
                })
                .catch(function (error) {
                    console.log(error.response);
                    // that.$noty.error('建立職位失敗');
                    that.$noty.error(
                        that.$t('ui.notifications.error.create__name', {
                            name: that.$t('models.roles')
                        })
                    );
                })
                .then(function() {
                    that.is_loading = true;
                });

        }
    },
    components: {
        PermissionsTable,
        ErrorMessages,
    }
}
</script>
